import React from 'react';
import { Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { getText } from 'function/language';

/**
 * 대시보드 > 추이 대시보드 - 탭
 */
const Tab = ({ type, setType }) => (
  <Nav
    activeKey={type}
    variant="tabs"
    onSelect={type => setType(Math.floor(type))}
  >
    {[
      'dashboardTrendRawMaterialPrice',
      'dashboardTrendProductOutput',
      'dashboardTrendRawMaterialPriceStock'
    ].map((value, index) => (
      <Nav.Item key={`types${index}`}>
        <Nav.Link eventKey={index}>{getText(value)}</Nav.Link>
      </Nav.Item>
    ))}
  </Nav>
);

Tab.propTypes = {
  // 구분 (0: 원료 가격 추이, 1: 제품 생산량 추이, 2: 원재료비 추이)
  type: PropTypes.number,

  // 구분 설정 함수
  setType: PropTypes.func.isRequired
};
Tab.defaultProps = { type: 0 };

export default Tab;
